export const FACULTIES: string[] = [
  'FSv',
  'FBMI',
  'FS',
  'FA',
  'CIIRC',
  'FEL',
  'UCEEB',
  'FD',
  'UTEF',
  'FJFI',
  'FIT',
];

export const YEAR_MIN = 2018;
export const YEAR_MAX = 2025;

export const RESULT_TYPES: string[] = [
  'Article',
  'Proceedings Paper',
  'Book',
  'Book Chapter',
  'Project',
  'Patent',
  'Software',
  'Functional Sample',
  'Utility Model',
  'Prototype',
  'Verified Technology',
  'Industrial Design',
  'Research Report',
  'Conference Paper',
];
